import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const variantClass = {
    active: "bg-[var(--status-active-bg)] text-[var(--status-active-text)]",
    completed: "bg-[var(--status-success-bg)] text-[var(--status-success-text)]",
    pending: "bg-[var(--status-pending-bg)] text-[var(--status-pending-text)]",
    warning: "bg-[var(--status-warning-bg)] text-[var(--status-warning-text)]",
    error: "bg-[var(--status-error-bg)] text-[var(--status-error-text)]",
    neutral: "bg-[var(--status-neutral-bg)] text-[var(--status-neutral-text)]",
    dispensary: "bg-[var(--dispensary-badge-bg)] text-[var(--dispensary-badge-text)]",
};
export function StatusBadge({ children, variant, dotClassName, }) {
    return (_jsxs("span", { className: `inline-flex items-center rounded-lg px-3 py-1 text-xs font-medium ${variantClass[variant]}`, children: [dotClassName ? (_jsx("span", { className: `mr-1.5 h-1.5 w-1.5 shrink-0 rounded-full ${dotClassName}` })) : null, children] }));
}
//# sourceMappingURL=StatusBadge.js.map